export default {"src":"/_next/static/media/GPN.a54db718.svg","height":18,"width":18};